<template>
<section>
    <b-field label="Event Name" horizontal>
        <b-input v-model="$root.event.name" @blur="saveEvent()"></b-input>
    </b-field>
    <b-field horizontal :type=" state.slug ? '' : 'is-danger' " class="field-switch-fix">
        <template slot="label">
            Slug
            <b-tooltip type="is-light" label="Der Slug wird in dem versendeten Ameldelink sichtbar, um dem Empfänger eine bessere Zuordnung zu ermöglichen Bsp: event.firma.com/SLUG" multilined>
                <b-icon size="is-small" icon="question-circle" pack="fal"></b-icon>
            </b-tooltip>
        </template>
        <p class="control">
            <b-switch v-model="lockSlug"></b-switch>
        </p>
        <b-input v-model="$root.event.slug" @input="checkSlug()" :disabled="lockSlug" @blur="checkSlug(true)"></b-input>
    </b-field>
    <b-field label="Abonnentenliste" horizontal class="field-switch-fix">
        <p class="control">
            <b-switch v-model="lockList"></b-switch>
        </p>
        <b-select v-if="typeof $root.env.account.lists !== 'array'" placeholder="Bitte Auswählen oder neu erstellen" v-model="$root.event.list" :disabled="lockList" expanded>
            <option v-for="option in $root.env.account.lists" :value="option.id" :key="option.id">
                {{ option.name }} ({{option.id}})
            </option>
        </b-select>
        <p class="control" v-if="!lockList">
            <button class="button is-primary" @click="newList()">
                <b-icon icon="plus" pack="fal"></b-icon>
            </button>
        </p>
    </b-field>
    <b-field label="Zeitraum" horizontal>
        <Rangepicker v-model="range" placeholder="Bitte auswählen..." icon="calendar-day" pack="fal" @change="saveEvent()" :inline="true">
        </Rangepicker>
    </b-field>
    <b-field label="Firmierung" horizontal>
        <b-select v-model="$root.event.firm" placeholder="Bitte wählen Sie die Firmierung:" @input="saveEvent()">
            <option v-for="(firm, key) in $root.settings.firms" :value="firm.id">
                #{{firm.id}}: {{firm.name}}
            </option>
        </b-select>
    </b-field>

    <b-field label="Interne Notizen" horizontal>
        <b-input maxlength="2000" v-model="$root.event.contact" type="textarea"></b-input>
    </b-field>

    <b-field label="Gruppen" horizontal>
        <p class="control">
            <b-taglist>
                <b-tag v-for="(group, index) in $root.event.groups"
                       type="is-light"
                       closable
                       aria-close-label="Löschen"
                       @close="$root.event.groups.splice(index,1)">
                    {{group.name}}
                </b-tag>
            </b-taglist>
        </p>
    </b-field>
    <b-field label="Zeitslots" horizontal>
        <p class="control">
            <b-taglist>
                <b-tag v-for="(group, index) in $root.event.slots"
                       type="is-light"
                       closable
                       aria-close-label="Löschen"
                       @close="$root.event.slots.splice(index,1)">
                    {{group.name}}
                </b-tag>
            </b-taglist>
        </p>
    </b-field>

</section>
</template>

<script>
import ImageResize from 'quill-image-resize-module'

export default {
    name: 'General',
    components: {

    },
    props: {

    },
    data() {
        return {
            selectedList: {},
            lockList: true,
            lockSlug: true,
            state: {
                slug: true
            },
            editorSettings: {
                modules: {
                    // imageDrop: true,
                    imageResize: {}
                }
            },
            customModulesForEditor: [{
                //     alias: "imageDrop",
                //     module: ImageDrop
                // }, {
                alias: "imageResize",
                module: ImageResize
            }],
            customToolbar: [
                [{
                    // header: [false, 1, 2, 3, 4, 5, 6]
                    header: [false, 1, 2]
                }],
                // ["bold", "italic", "underline", "strike"], // toggled buttons
                ["bold", "italic", "underline"], // toggled buttons
                [{
                        align: ""
                    },
                    {
                        align: "center"
                    },
                    {
                        align: "right"
                    },
                    {
                        align: "justify"
                    }
                ],
                ["blockquote", "code-block"],
                [{
                    list: "ordered"
                }, {
                    list: "bullet"
                }, {
                    list: "check"
                }],
                [{
                    indent: "-1"
                }, {
                    indent: "+1"
                }], // outdent/indent
                [{
                    color: []
                }, {
                    background: []
                }], // dropdown with defaults from theme
                ["link", "image", "video"],
                // ["link", "image"],
                ["clean"]
            ]
        }
    },
    methods: {
        update(id = this.$route.params.id) {

            return true
        },
        saveEvent() {
            this.$root.saveEvent(this.$route.params.id)
        },
        updateLists() {
            this.$root.getAccount()
        },
        newList() {
            this.$buefy.dialog.prompt({
                message: `Listenname?`,
                inputAttrs: {
                    value: this.$root.event.name,
                    maxlength: 50
                },
                onConfirm: (value) => this.$root.postAccount('list', {
                    name: value
                })
            })
        },
        checkSlug(save = false) {
            this.state.slug = true
            var patt = new RegExp(/^([a-z][a-z0-9-_]*)$/, "");
            if (!patt.test(this.$root.event.slug)) {
                this.state.slug = false
            }
            this.$root.events.forEach(event => {
                if (event.slug == this.$root.event.slug) {
                    this.state.slug = false
                }
            })
            if (!this.state.slug) {
                return
            }
            if (save) {
                this.saveEvent()
                return
            }
        },
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            // An example of using FormData
            // NOTE: Your key could be different such as:
            // formData.append('file', file)

            this.$root.uploadAsset(file, data => {
                Editor.insertEmbed(cursorLocation, "image", data.url);
                resetUploader();
            })

        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed
        this.updateLists()
        this.update()
    },
    computed: {
        range: {
            get() {

                return [this.$root.event.start, this.$root.event.end]

            },
            set(val) {
                this.$root.event.start = val[0]
                this.$root.event.end = val[1]
                return true
            }
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.c-preview {
    width: 50px;
}

.hover-rotate-90 .dropdown-trigger .icon i {
    transition: transform .8s ease;
}

.hover-rotate-90.is-active .dropdown-trigger .icon i,
.hover-rotate-90:hover .dropdown-trigger .icon i {
    transform: rotate(90deg);
}
</style>
